/**
 * Botão de ícone da toolbar da mesa, com tooltip (E37.F2). Extraído do // ux-neutrality:allow doc-comment
 * ContestedToolbar na E47.F3 para ser compartilhado com o ContestedToolsGroup. // ux-neutrality:allow doc-comment
 */
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/Tooltip';
import { cn } from '@/lib/utils';

export interface ToolBtnProps {
  testId: string;
  icon: React.ReactNode;
  label: string;
  hint?: string;
  pressed?: boolean;
  disabled?: boolean;
  primary?: boolean;
  onClick: () => void;
}

export function ToolBtn({
  testId,
  icon,
  label,
  hint,
  pressed,
  disabled,
  primary = false,
  onClick,
}: ToolBtnProps): JSX.Element {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          aria-label={label}
          aria-pressed={pressed}
          disabled={disabled}
          onClick={onClick}
          className={cn('toolbar-btn', primary && 'toolbar-btn--primary')}
        >
          {icon}
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{label}</p>
        {hint && <p className="toolbar-tooltip-hint">{hint}</p>}
      </TooltipContent>
    </Tooltip>
  );
}
